import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addNewJob } from "./AddNewJobApi";


const initialState = {
    job: {},
    isLoading: false,
    isError: false,
    error: "",
};

export const AddNewJob = createAsyncThunk('addNewJobs/addJob', async(job) =>{
    const newJob = await addNewJob(job);
    return newJob;
})
    
const jobSlice = createSlice({
    name: "addJobrtrt",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(AddNewJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(AddNewJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.job = action.payload;
            })
            .addCase(AddNewJob.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
                state.job = [];
            })
        }
})


export default jobSlice.reducer;